
import { ActionTree } from 'vuex'
import axios, {AxiosResponse} from "axios";

export const actions: ActionTree<any, any> = {

    sendTeamMessage: ({state, getters, commit, dispatch}, message) => {

        return new Promise((resolve, reject) => {

            axios.post('/chat', message)

                .then((response: AxiosResponse) => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
        });
    },

    sendPrivateMessage: ({state, getters, commit, dispatch}, data) => {

        return new Promise((resolve, reject) => {

            axios.post('/chat-private', {receiverId: data.user.id, message: data.message})

                .then((response: AxiosResponse) => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
        });
    },
};
